import { AppliedLessonLike } from '@/helpers/filter/appliedLessons/filterAppliedLessonTypes';

export const filterAppliedLessonsDynamicField = (appliedLesson: AppliedLessonLike, dynamicFields: string[]) => {
    return (
        dynamicFields.length === 0 ||
        dynamicFields.some((df) => appliedLesson.dynamic_field && df === appliedLesson.dynamic_field.title)
    );
};
